// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui-icon-action-button {
  position: relative;
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
  max-width: 36px;
  max-height: 36px;
  aspect-ratio: 1 / 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid rgba(12, 20, 39, 0.08);
  background: #f8fafc;
  color: #0f172a;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
  transition: transform 0.15s ease, box-shadow 0.2s ease, filter 0.2s ease;
  padding: 0;
}

.ui-icon-action-button i.material-icons {
  font-size: 18px;
}

.ui-icon-action-button:hover {
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.1);
  transform: translateY(-1px);
}

.ui-icon-action-button:active {
  transform: translateY(0);
}

.ui-icon-action-button[disabled] {
  opacity: 1;
  cursor: not-allowed;
  box-shadow: none;
  background: #f1f5f9;
  color: #9ca3af;
  border-color: rgba(148, 163, 184, 0.45);
}

.spinner-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.spinner-overlay .mat-progress-spinner {
  width: auto;
  height: auto;
}

.action-button--indigo {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.12), rgba(96, 165, 250, 0.08));
  color: #1d4ed8;
  border-color: rgba(59, 130, 246, 0.32);
}

.action-button--muted {
  background: #f8fafc;
  color: #0f172a;
  border-color: rgba(12, 20, 39, 0.08);
}

.action-button--ghost {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.08), rgba(255, 255, 255, 0.9));
  color: #1f2937;
  border-color: rgba(59, 130, 246, 0.22);
}

.action-button--warning {
  background: linear-gradient(135deg, #fff7ed, #fffbeb);
  color: #b45309;
  border-color: rgba(244, 158, 11, 0.32);
}

.action-button--danger {
  background: linear-gradient(135deg, #fef2f2, #fff1f2);
  color: #b91c1c;
  border-color: rgba(239, 68, 68, 0.32);
}

.action-button--success {
  background: linear-gradient(135deg, #ecfdf3, #f0fdf4);
  color: #15803d;
  border-color: rgba(16, 185, 129, 0.32);
}
`, "",{"version":3,"sources":["webpack://./projects/admin/src/components/ui-button/icon-action-button/icon-action-button.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,cAAc;EACd,6CAA6C;EAC7C,wEAAwE;EACxE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uFAAuF;EACvF,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,uFAAuF;EACvF,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,sCAAsC;AACxC","sourcesContent":[".ui-icon-action-button {\n  position: relative;\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n  min-height: 36px;\n  max-width: 36px;\n  max-height: 36px;\n  aspect-ratio: 1 / 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  border: 1px solid rgba(12, 20, 39, 0.08);\n  background: #f8fafc;\n  color: #0f172a;\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);\n  transition: transform 0.15s ease, box-shadow 0.2s ease, filter 0.2s ease;\n  padding: 0;\n}\n\n.ui-icon-action-button i.material-icons {\n  font-size: 18px;\n}\n\n.ui-icon-action-button:hover {\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.1);\n  transform: translateY(-1px);\n}\n\n.ui-icon-action-button:active {\n  transform: translateY(0);\n}\n\n.ui-icon-action-button[disabled] {\n  opacity: 1;\n  cursor: not-allowed;\n  box-shadow: none;\n  background: #f1f5f9;\n  color: #9ca3af;\n  border-color: rgba(148, 163, 184, 0.45);\n}\n\n.spinner-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.spinner-overlay .mat-progress-spinner {\n  width: auto;\n  height: auto;\n}\n\n.action-button--indigo {\n  background: linear-gradient(135deg, rgba(59, 130, 246, 0.12), rgba(96, 165, 250, 0.08));\n  color: #1d4ed8;\n  border-color: rgba(59, 130, 246, 0.32);\n}\n\n.action-button--muted {\n  background: #f8fafc;\n  color: #0f172a;\n  border-color: rgba(12, 20, 39, 0.08);\n}\n\n.action-button--ghost {\n  background: linear-gradient(135deg, rgba(59, 130, 246, 0.08), rgba(255, 255, 255, 0.9));\n  color: #1f2937;\n  border-color: rgba(59, 130, 246, 0.22);\n}\n\n.action-button--warning {\n  background: linear-gradient(135deg, #fff7ed, #fffbeb);\n  color: #b45309;\n  border-color: rgba(244, 158, 11, 0.32);\n}\n\n.action-button--danger {\n  background: linear-gradient(135deg, #fef2f2, #fff1f2);\n  color: #b91c1c;\n  border-color: rgba(239, 68, 68, 0.32);\n}\n\n.action-button--success {\n  background: linear-gradient(135deg, #ecfdf3, #f0fdf4);\n  color: #15803d;\n  border-color: rgba(16, 185, 129, 0.32);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
